var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 11.5243C18.3337 10.8531 18.0383 10.23 17.5233 9.81494L16.2503 8.78877V8.78864L11.5355 4.98786C10.8785 4.45817 10.0561 4.1665 9.21997 4.1665H1.66699V13.6998H16.2091C17.3806 13.6998 18.3337 12.7239 18.3337 11.5243ZM14.6716 8.78877H10.1413V7.65544H13.2657L14.6716 8.78877ZM9.16478 6.65544V9.78877H15.9121L16.9193 10.6007C17.1975 10.8251 17.3571 11.1617 17.3571 11.5243C17.3571 12.1725 16.8421 12.6998 16.2091 12.6998H2.64355V9.78877H7.36361V6.65544H2.64355V5.1665H9.21997C9.83795 5.1665 10.4459 5.38213 10.9315 5.77367L12.0253 6.65544H9.16478ZM2.64355 7.65544H6.38704V8.78877H2.64355V7.65544ZM1.66699 14.8332H18.3337V15.8332H1.66699V14.8332Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.ea5c2d64614687b99f36e0a8316f23c8.svg";
export { ForwardRef as ReactComponent };